import { InvoiceIssueTypeInternational } from '../../../../enums';

export interface IInvoiceSubtypeInt {
    issueType: InvoiceIssueTypeInternational;
    invoiceErrorTypeOtherInfo?: string;
    errorsIdentifiedWithin24hours: boolean;
    invoiceMatchesIODC?: boolean;
}
